<template>
  <el-dropdown
      @command="handleLanguageChange"
      placement="bottom-right"
      class="language-switch"
  >
    <span class="el-dropdown-link">
      <i class="el-icon-globe" style="margin-right: 5px;"></i>
      {{ currentLanguageLabel }}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
          v-for="lang in languages"
          :key="lang.value"
          :command="lang.value"
          :disabled="currentLanguage === lang.value"
      >
        {{ lang.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'LanguageSwitch',
  data() {
    return {
      languages: [
        { value: 'zh-CN', label: '中文' },
        { value: 'en-US', label: 'English' }
      ]
    };
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale || localStorage.getItem('language') || 'zh-CN';
    },
    currentLanguageLabel() {
      const lang = this.languages.find(item => item.value === this.currentLanguage);
      return lang ? lang.label : '中文';
    }
  },
  mounted() {
    const savedLang = localStorage.getItem('language');
    if (savedLang && this.$i18n.locale !== savedLang) {
      this.$i18n.locale = savedLang;
    }
  },
  methods: {
    handleLanguageChange(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('language', lang);
      this.$bus && this.$bus.$emit('language-changed', lang);
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.language-switch {
  display: inline-block;
  margin-left: 15px;
  color: #fff;
  cursor: pointer;
}

.el-dropdown-link {
  color: inherit;
  display: flex;
  align-items: center;
}

.el-dropdown-menu__item[disabled] {
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>